import { Tabs, Tab, TabContent } from "./style";

import { useDispatch, useSelector } from "react-redux";
import {
  listFeedbackManagerDataSelector,
  selectListArriveLateManager,
  selectListRequestLeaveManager,
  startDateSelector,
} from "modules/DeclareLeave/redux/selector";

import { ListArriveLate } from "./ArriveLate";
import { ListLeaveRequest } from "./LeaveRequest";
import { useLegacyEffect } from "helper/customHook";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import "moment/locale/vi"; // Import Vietnamese locale
import { Box } from "@mui/material";
import pxToRem from "theme/base/pxToRem";
import {
  getListArriveLateManagerStart,
  setMonthYearListArriveLateManager,
} from "modules/DeclareLeave/redux/getListArriveLateManager";
import {
  getListRequestLeaveManagerStart,
  setMonthYearListRequestLeaveManager,
} from "modules/DeclareLeave/redux/getListRequestLeaveManager";
import { useNavigate, useParams } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";
import { SCREEN } from "helper/roleChecker/Screens";
import { ReactComponent as ArrowDown } from "assets/svg/chevron_down.svg";

import { ListFeedback } from "./ListRespone";
import {
  getListFeedbackManagerStart,
  setMonthYearListFeedbackManager,
} from "modules/DeclareLeave/redux/getListFeedbackManager";
import { declareLeaveURL } from "modules/DeclareLeave/Pages/Main/DeclareLeaveContent/index";
import {
  getConfigMinDateStart,
  updateConfigMinDate,
} from "modules/DeclareLeave/redux/getConfigMinDate";
import { useEffect } from "react";
import { PopupConfirm } from "./PopupConfirm";
export const OrderManagement = () => {
  const { type } = useParams();
  const navigate = useNavigate();

  const locale = "vi";
  if (moment.locale() !== locale) {
    moment.locale(locale);
  }

  const dispatch = useDispatch();

  const dataArriveLate = useSelector(selectListArriveLateManager);
  const dataLeave = useSelector(selectListRequestLeaveManager);
  const listFeedback = useSelector(listFeedbackManagerDataSelector);
  const startDate = useSelector(startDateSelector);

  const fetchData = (timeValue, tab?: string) => {
    const tabSelected = tab || type;
    const payload = {
      screenCode: SCREEN.IP_017,
      month: timeValue?.format("M"),
      year: timeValue?.format("YYYY"),
      limit: 60,
      offset: 0,
    };
    if (tabSelected === declareLeaveURL.lackOfTime) {
      dispatch(getListArriveLateManagerStart(payload));
    } else if (tabSelected === declareLeaveURL.feedback) {
      dispatch(getListFeedbackManagerStart(payload));
    } else {
      dispatch(getListRequestLeaveManagerStart(payload));
    }
  };

  const handleClickNavigate = (tabContent: string) => {
    // // lấy lại config date để tính toán lại tháng chấm công
    // dispatch(getConfigMinDateStart());
    fetchData(startDate, tabContent);
    navigate(
      `${pathRoutes.declareLeave.base}/${declareLeaveURL.orderManagement}/${tabContent}`
    );
  };

  const handleChangeMonth = (newValue: any) => {
    const timeSelected = {
      month: newValue.month() + 1,
      year: newValue.year(),
    };

    dispatch(setMonthYearListArriveLateManager(timeSelected));
    dispatch(setMonthYearListFeedbackManager(timeSelected));
    dispatch(setMonthYearListRequestLeaveManager(timeSelected));

    dispatch(updateConfigMinDate(newValue));
    fetchData(newValue);
  };

  useLegacyEffect(() => {
    if (!startDate) return;
    dispatch(
      getListArriveLateManagerStart({
        screenCode: SCREEN.IP_017,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      })
    );
    dispatch(
      getListRequestLeaveManagerStart({
        screenCode: SCREEN.IP_017,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      })
    );
    dispatch(
      getListFeedbackManagerStart({
        screenCode: SCREEN.IP_017,
        year: startDate.year(),
        month: startDate.month() + 1,
        limit: 60,
        offset: 0,
      })
    );
  }, [startDate]);

  useEffect(() => {
    return () => {
      // lấy lại config date để tính toán lại tháng chấm công
      dispatch(getConfigMinDateStart());
    };
  }, []);

  return (
    <>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        paddingRight={pxToRem(20)}
        flexWrap={"wrap"}
      >
        <Tabs>
          <Tab
            active={!type || type === "leave"}
            onClick={() => handleClickNavigate("leave")}
            fontWeight={500}
          >
            Đơn xin nghỉ ({dataLeave.length})
          </Tab>

          <Tab
            active={type === declareLeaveURL.lackOfTime}
            onClick={() => handleClickNavigate(declareLeaveURL.lackOfTime)}
            fontWeight={500}
          >
            Đơn xin đi muộn/về sớm ({dataArriveLate.length})
          </Tab>
          <Tab
            active={type === declareLeaveURL.feedback}
            onClick={() => handleClickNavigate(declareLeaveURL.feedback)}
            fontWeight={500}
          >
            Đơn phản hồi ({listFeedback.length})
          </Tab>
        </Tabs>
        <Box
          display={"flex"}
          alignItems={"center"}
          gap={1}
          sx={(theme) => ({
            [theme.breakpoints.down("md")]: {
              paddingLeft: pxToRem(20),
            },
          })}
        >
          <Box display={"flex"} alignItems={"center"}>
            Tháng
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              adapterLocale={locale}
            >
              <DatePicker
                views={["month", "year"]}
                sx={{
                  fieldset: {
                    border: "none",
                  },
                  ".MuiInputBase-root.MuiOutlinedInput-root": {
                    paddingRight: 0,
                    input: {
                      width: pxToRem(65),
                      textTransform: "capitalize",
                      fontSize: pxToRem(14),
                      paddingLeft: pxToRem(4),
                    },
                  },
                  ".MuiInputAdornment-root.MuiInputAdornment-positionEnd": {
                    opacity: 0,
                    position: "absolute",
                    right: pxToRem(50),
                    button: {
                      width: pxToRem(140),
                      marginRight: `-${pxToRem(75)}`,
                    },
                  },
                }}
                value={startDate}
                format="MM - YYYY"
                slots={{ actionBar: () => null }}
                closeOnSelect={true}
                onChange={handleChangeMonth}
              />
            </LocalizationProvider>
          </Box>
          <ArrowDown />
        </Box>
      </Box>
      <TabContent
        sx={(theme) => ({
          tbody: {
            tr: {
              "&:hover": {
                backgroundColor: `${theme.palette.background.bgBrandPrimary} !important`,
                cursor: "pointer",
              },
            },
            td: {
              fontSize: `12px !important`,
            },
          },
        })}
      >
        {(!type ||
          type === declareLeaveURL.leave ||
          type === declareLeaveURL.earlyRegistration) && <ListLeaveRequest />}
        {type === declareLeaveURL.lackOfTime && <ListArriveLate />}
        {type === declareLeaveURL.feedback && <ListFeedback />}
      </TabContent>
      <PopupConfirm />
    </>
  );
};
